export default {
  data() {
    return {
      payWay: '1',
      amount: null
    };
  },
  methods: {
    setAmount(val) {
      this.amount = val === '' ? null : val;
    },
    setPayway(val) {
      this.payWay = val;
    }
  }
};
